module.exports = __webpack_public_path__ + "img/carshinaused_10.0088272c.jpg";